import styled from "styled-components/macro";

import background from "Payments/CreditCardAssets/CardBackgrounds/discover_texture.jpg";
import logo from "Payments/CreditCardAssets/LargeCardLogos/discover_logo.png";

export default function Visa() {
  return (
    <>
      <Background />
      <Logo />
      <CircleOutter>
        <CircleInner></CircleInner>
        <ItText>it</ItText>
      </CircleOutter>
    </>
  );
}

const Background = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url(${background});
  background-size: cover;
  background-position: center center;
`;

const Logo = styled.div`
  position: absolute;
  top: 22%;
  left: 0;
  right: 0;
  height: 32px;
  background-image: url(${logo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  .width_360 & {
    height: 28px;
  }
  .width_320 & {
    height: 20px;
  }
`;

const CircleOutter = styled.div`
  height: 80px;
  position: absolute;
  width: 80px;
  border-radius: 80px;
  background-image: linear-gradient(
    to top right,
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.1)
  );
  right: -40px;
  top: 11%;
  margin-bottom: -24px;
  display: flex;
  align-items: center;
  justify-content: center;
  .width_360 & {
    top: 14%;
    width: 60px;
    height: 60px;
    right: -30px;
  }
  .width_320 & {
    width: 50px;
    height: 50px;
    right: -25px;
  }
`;

const CircleInner = styled.div`
  height: 70px;
  width: 70px;
  border-radius: 80px;
  background-image: url(${background});
  background-size: 400px;
  background-position: top right;
  filter: brightness(1.6);
  box-shadow: inset rgba(0, 0, 0, 1) 1px 2px 4px;
  .width_360 & {
    width: 54px;
    height: 54px;
  }
  .width_320 & {
    width: 44px;
    height: 44px;
  }
`;
const ItText = styled.div`
  position: absolute;
  color: #fff;
  font-size: 36px;
  left: 12px;
  font-family: Arial;
  opacity: 0.9;
  .width_360 & {
    font-size: 28px;
  }
  .width_320 & {
    font-size: 22px;
    left: 10px;
  }
`;
